<template>
  <div v-if="data">
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-5">
          <img src="@/assets/img/logout.svg?data" class="logout" alt="Logged out" />
          <div v-html="data.error.sessionNoLongerActiveText"></div>
          <div class="clearfix"></div>
          <button class="btn btn-primary btn-block" @click="$router.push('/')" v-html="data.misc.toStartBtn"></button>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import { showDelayText } from '../plugins/delayhandler'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'sessionexp',
  components: {
    // Survey
  },
  data () {
    return {
      data: null
    }
  },
  methods: {
    resetConsent () {
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      axios._post(config.optOutUri).then(response => {
        if (response) {
          loader.hide()
          this.$router.push('/consent')
        }
      }, (error) => {
        if (error.response) {
          loader.hide()
          window.location.href = window.location.origin.concat('/error')
        }
      })
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          misc(locale: ` + sessionStorage.getItem('language') + `) {
            goBackBtn
            toStartBtn
          }
          error(locale: ` + sessionStorage.getItem('language') + `) {
            sessionNoLongerActiveText
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
button:disabled {
  opacity: 0.3;
}
.logout {
  width: 60px;
  height: 60px;
  margin-bottom: 5vh;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  .card {
    margin-top: 2vh;
  }
  .container {
    margin-bottom: -6.5vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SessionExpired.vue